import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  PL_API_CONFIG,
  PlAPIConfig,
  PlAuthService,
  PLAuthState,
  selectAuth,
  User,
} from 'pl-core-services';
import { Store } from '@ngrx/store';
import { HttpClient } from '@angular/common/http';

@UntilDestroy()
@Component({
  selector: 'pl-hijack',
  templateUrl: 'hijack.component.html',
  styleUrls: ['./hijack.component.scss'],
})
export class HijackComponent implements OnInit {
  hijacked = false;

  @HostBinding('class.open')
  hijackOpened = true;

  user: User;

  releaseUrl: string;

  constructor(
    @Inject(PL_API_CONFIG) private config: PlAPIConfig,
    private store: Store,
    private authService: PlAuthService,
    private httpClient: HttpClient
  ) {
    this.releaseUrl = `${config.login_url}/hijack/release-hijack/`;
  }

  ngOnInit() {
    this.store
      .select(selectAuth)
      .pipe(untilDestroyed(this))
      .subscribe((authState: PLAuthState) => {
        this.hijacked = authState.hijacked;
        this.user = authState.currentUser;
      });
  }

  get username() {
    return this.user?.username;
  }

  @HostBinding('style.display')
  get styleDisplay() {
    return this.hijacked ? null : 'none';
  }

  onClickRelease() {
    this.httpClient.get(this.releaseUrl, { withCredentials: true }).subscribe({
      next: () => this.gotoAdmin(),
      error: (e) => {
        // release-hijack redirects and causes a CORS error,
        // so we get user status to see if the release worked
        if (e.status === 0) {
          this.authService.getUserStatus().subscribe(({ user }) => {
            if (user.uuid !== this.user.uuid) {
              this.gotoAdmin();
            }
          });
        }
        // rethrow since we didn't handle the error very neatly
        throw e;
      },
    });
  }

  gotoAdmin() {
    window.location.assign(`${this.config.login_url}/admin`);
  }
}
